'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.customToJS = exports.populatedDataToJS = exports.buildChildList = exports.orderedToJS = exports.dataToJS = exports.pathToJS = exports.toJS = exports.fixPath = exports.isEmpty = exports.isLoaded = undefined;

var _defaultsDeep2 = require('lodash/defaultsDeep');

var _defaultsDeep3 = _interopRequireDefault(_defaultsDeep2);

var _isFunction2 = require('lodash/isFunction');

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _isString2 = require('lodash/isString');

var _isString3 = _interopRequireDefault(_isString2);

var _reduce2 = require('lodash/reduce');

var _reduce3 = _interopRequireDefault(_reduce2);

var _every2 = require('lodash/every');

var _every3 = _interopRequireDefault(_every2);

var _mapValues2 = require('lodash/mapValues');

var _mapValues3 = _interopRequireDefault(_mapValues2);

var _drop2 = require('lodash/drop');

var _drop3 = _interopRequireDefault(_drop2);

var _first2 = require('lodash/first');

var _first3 = _interopRequireDefault(_first2);

var _some2 = require('lodash/some');

var _some3 = _interopRequireDefault(_some2);

var _map2 = require('lodash/map');

var _map3 = _interopRequireDefault(_map2);

var _split2 = require('lodash/split');

var _split3 = _interopRequireDefault(_split2);

var _last2 = require('lodash/last');

var _last3 = _interopRequireDefault(_last2);

var _has2 = require('lodash/has');

var _has3 = _interopRequireDefault(_has2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _set2 = require('lodash/set');

var _set3 = _interopRequireDefault(_set2);

var _size2 = require('lodash/size');

var _size3 = _interopRequireDefault(_size2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _populate = require('./utils/populate');

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var isLoaded = exports.isLoaded = function isLoaded() {
  if (!arguments || !arguments.length) {
    return true;
  }

  return (0, _map3.default)(arguments, function (a) {
    return a !== undefined;
  }).reduce(function (a, b) {
    return a && b;
  });
};

var isEmpty = exports.isEmpty = function isEmpty(data) {
  return !(data && (0, _size3.default)(data));
};

var fixPath = exports.fixPath = function fixPath(path) {
  return (path.substring(0, 1) === '/' ? '' : '/') + path;
};

var toJS = exports.toJS = function toJS(data) {
  return data && data.toJS ? data.toJS() : data;
};

var pathToJS = exports.pathToJS = function pathToJS(data, path, notSetValue) {
  if (!data) {
    return notSetValue;
  }
  var pathArr = fixPath(path).split(/\//).slice(1);

  if (data.getIn) {
    if ((0, _some3.default)(_constants.metaParams, function (v) {
      return pathArr.indexOf(v) !== -1;
    })) {
      return toJS(data.getIn([(0, _first3.default)(pathArr), (0, _drop3.default)(pathArr).join(_constants.paramSplitChar)], notSetValue));
    }
    return toJS(data.getIn(pathArr, notSetValue));
  }

  return data;
};

var dataToJS = exports.dataToJS = function dataToJS(data, path, notSetValue) {
  if (!data) {
    return notSetValue;
  }

  var pathArr = ('/data' + fixPath(path)).split(/\//).slice(1);

  if (data.getIn) {
    return toJS(data.getIn(pathArr, notSetValue));
  }

  return data;
};

var orderedToJS = exports.orderedToJS = function orderedToJS(data, path, notSetValue) {
  if (!data) {
    return notSetValue;
  }

  var pathArr = ('/ordered' + fixPath(path)).split(/\//).slice(1);

  if (data.getIn) {
    return toJS(data.getIn(pathArr, notSetValue));
  }

  return data;
};

var buildChildList = exports.buildChildList = function buildChildList(data, list, p) {
  return (0, _mapValues3.default)(list, function (val, key) {
    var getKey = val;

    if (val === true) {
      getKey = key;
    }
    var pathString = p.childParam ? p.root + '/' + getKey + '/' + p.childParam : p.root + '/' + getKey;

    if (dataToJS(data, pathString)) {
      return p.keyProp ? _extends(_defineProperty({}, p.keyProp, getKey), dataToJS(data, pathString)) : dataToJS(data, pathString);
    }

    return val === true ? val : getKey;
  });
};

var populatedDataToJS = exports.populatedDataToJS = function populatedDataToJS(data, path, populates, notSetValue) {
  if (!data) {
    return notSetValue;
  }

  if (!dataToJS(data, path, notSetValue)) {
    return dataToJS(data, path, notSetValue);
  }

  var populatesForData = (0, _populate.getPopulateObjs)((0, _isFunction3.default)(populates) ? populates((0, _last3.default)((0, _split3.default)(path, '/')), dataToJS(data, path)) : populates);
  var dataHasPopluateChilds = (0, _every3.default)(populatesForData, function (populate) {
    return (0, _has3.default)(dataToJS(data, path), populate.child);
  });

  if (dataHasPopluateChilds) {
    return (0, _reduce3.default)((0, _map3.default)(populatesForData, function (p, obj) {
      if ((0, _isString3.default)((0, _get3.default)(dataToJS(data, path), p.child))) {
        var key = (0, _get3.default)(dataToJS(data, path), p.child);
        var pathString = p.childParam ? p.root + '/' + key + '/' + p.childParam : p.root + '/' + key;
        if (dataToJS(data, pathString)) {
          return (0, _set3.default)({}, p.child, p.keyProp ? _extends(_defineProperty({}, p.keyProp, key), dataToJS(data, pathString)) : dataToJS(data, pathString));
        }

        return dataToJS(data, path);
      }
      return (0, _set3.default)({}, p.child, buildChildList(data, (0, _get3.default)(dataToJS(data, path), p.child), p));
    }), function (obj, v) {
      return (0, _defaultsDeep3.default)(v, obj);
    }, dataToJS(data, path));
  } else {
    return (0, _mapValues3.default)(dataToJS(data, path), function (child, childKey) {
      var populatesForDataItem = (0, _populate.getPopulateObjs)((0, _isFunction3.default)(populates) ? populates(childKey, child) : populates);
      var resolvedPopulates = (0, _map3.default)(populatesForDataItem, function (p, obj) {
        if (!child || !(0, _get3.default)(child, p.child)) {
          return child;
        }

        if ((0, _isString3.default)((0, _get3.default)(child, p.child))) {
          var key = (0, _get3.default)(child, p.child);
          var pathString = p.childParam ? p.root + '/' + key + '/' + p.childParam : p.root + '/' + key;
          if (dataToJS(data, pathString)) {
            return (0, _set3.default)({}, p.child, p.keyProp ? _extends(_defineProperty({}, p.keyProp, key), dataToJS(data, pathString)) : dataToJS(data, pathString));
          }

          return child;
        }

        return (0, _set3.default)({}, p.child, buildChildList(data, (0, _get3.default)(child, p.child), p));
      });

      return (0, _reduce3.default)(resolvedPopulates, function (obj, v) {
        return (0, _defaultsDeep3.default)(v, obj);
      }, child);
    });
  }
};

var customToJS = exports.customToJS = function customToJS(data, path, custom, notSetValue) {
  if (!data) {
    return notSetValue;
  }

  var pathArr = ('/' + custom + fixPath(path)).split(/\//).slice(1);

  if (data.getIn) {
    return toJS(data.getIn(pathArr, notSetValue));
  }

  return data;
};

exports.default = {
  toJS: toJS,
  pathToJS: pathToJS,
  dataToJS: dataToJS,
  orderedToJS: orderedToJS,
  populatedDataToJS: populatedDataToJS,
  customToJS: customToJS,
  isLoaded: isLoaded,
  isEmpty: isEmpty
};


//////////////////
// WEBPACK FOOTER
// ../~/react-redux-firebase/es/helpers.js
// module id = 1187
// module chunks = 0